import React from "react";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { CardAula } from "./styles";
import { ClubeAula } from "../../../types/Clube";

interface AulaCardProps {
  aula: ClubeAula;
  onClick?: () => void;
}

// Card = só a imagem (capa). Título/tag já vêm estilizados na própria arte.
const AulaCard: React.FC<AulaCardProps> = ({ aula, onClick }) => {
  const { theme } = useTheme();
  const pct = Number(aula.porcentagem || 0);

  return (
    <CardAula theme={theme} onClick={onClick}>
      {aula.thumb && <img className="capa" src={aula.thumb} alt={aula.titulo} />}
      {pct > 0 && (
        <div className="barra-progresso">
          <div className="preenchido" style={{ width: `${pct}%` }} />
        </div>
      )}
    </CardAula>
  );
};

export default AulaCard;
